import React from 'react';
import { connect } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import MaterialOpaqueDetail from '../../components/material_opaque/MaterialOpaqueDetail';
import { editMaterialOpaque } from '../../redux/material_opaque/material_actions';
import { defaultRejectHandler } from '../../utils/utility';

class MaterialOpaqueEditModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };
  }

  onSaveHandler() {
    const newMaterial = this.materialDetail.getWrappedInstance().getMaterialData();
    this.props.editMaterial({ ...newMaterial, id: this.props.material.id });
  }

  render() {
    const { isEditing, errorMessage, material, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-lg">
            {t('edit opaque material')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <MaterialOpaqueDetail
            material={material}
            ref={ref => (this.materialDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isEditing && !this.props.isEdited && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="material-opaque-submit-edit"
            disabled={!isSubmittable || isEditing}
            onClick={() => this.onSaveHandler()}
          >
            {isEditing ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  errorMessage: state.material.opaque.errorMessage,
  isEditing: state.material.opaque.isEditing,
});

const mapDispatchToProps = dispatch => ({
  editMaterial: material => defaultRejectHandler(dispatch(editMaterialOpaque(material.id, material.name, material.density, material.specific_heat, material.thermal_conductivity, material.description, material.image, material.cfp_value, material.cfp_unit))),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(MaterialOpaqueEditModal)
);



// WEBPACK FOOTER //
// ./src/modal/material_opaque/MaterialOpaqueEditModal.js